var React = require('react');

function RightArrowSmall (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Footer-Mobile","transform":"translate(-183.000000, -66.000000)","fill":"#222A35","fillRule":"nonzero"},React.createElement("g",{"id":"Footer"},React.createElement("path",{"id":"Line-2-Copy-3","d":"M200.309343,66.5690816 L209.519864,71.75 L200.309343,76.9309184 L199.819082,76.0593429 L206.591,72.25 L183.5,72.25 L183.5,71.25 L206.591,71.25 L199.819082,67.4406571 L200.309343,66.5690816 Z"})))));
}

RightArrowSmall.defaultProps = {"width":"27px","height":"11px","viewBox":"0 0 27 11","version":"1.1"};

module.exports = RightArrowSmall;

RightArrowSmall.default = RightArrowSmall;
